import React from 'react';
import clsx from 'clsx';

import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y } from 'swiper/modules';

import Section from '@common/Section';
import Container from '@common/Container';
import Heading from '@common/Heading';
import Quote from '@common/Quote';
import RichText from '@common/RichText';
import Img from '@common/Image';

import ProfileImage from './ProfileImage';

import * as styles from '@styles/modules/block.module.scss';

const ReviewSliderImages = ({ data }) => {
  const {
    title,
    showTitle,
    list
  } = data;
  return (
    <Section>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {list &&
          <Swiper
            modules={[A11y]}
            slidesPerView={1}
            spaceBetween={20}
            breakpoints={{
            1200: {
              slidesPerView: list.length,
              spaceBetween: 20
            },
            992: {
              slidesPerView: 2.5,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 1.75,
              spaceBetween: 20
            }
            }}>
            {list.map((review, index) => (
              <SwiperSlide key={index} className='d-flex flex-column border border-3 border-dark-grey-4 bg-white rounded'>
                <div className={'d-flex flex-column flex-fill position-relative align-items-center mt-4 mb-5'}>
                    <Quote colour={review.bgColour} width={'38'} height={'30'}/>
                    {review.review && <RichText json={review.review} b='fw-bold' p='fs-16 px-2 mt-4'/>}
                  </div>
                  <div className={clsx('d-flex flex-column p-1 align-items-center position-relative text-center', {[`bg-${review.bgColour}`] : review.bgColour})} style={{maxHeight: 171}}>
                    <div className={clsx('bg-white', styles.reviewsCardAltImage)}>
                      {!review.image && <ProfileImage colour={review.bgColour}/>}
                      {review.image &&
                        <Img
                          placeholder='blurred'
                          image={review.image.gatsbyImageData}
                          file={review.image.file}
                          alt={review.image.description}
                          style={{ maxHeight: '98px', maxWidth: '98px', aspectRatio: '1/1' }}
                        />
                      }
                    </div>
                    <div className='d-flex flex-column align-items-center pb-3' style={{paddingTop: 48}}>
                      {review.name && <p className='fs-18 fw-semibold mb-2'>{review.name}</p>}
                      {review.company && <p className='fs-14 mb-2'>{review.company}</p>}
                      {review.title && <p className='fs-14 fw-bold mb-0'>{review.title}</p>}
                    </div>
                  </div>
              </SwiperSlide>
            ))}
          </Swiper>
        }
      </Container>
    </Section>
  )
}

export default ReviewSliderImages
